import { TemplateRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@progress/kendo-angular-dialog";
/**
 ****************************************************************
 * Popup window service.
 *
 * Created by Shai Zelman on 17/04/2020.
 ****************************************************************
 */
var PopupWindowService = /** @class */ (function () {
    function PopupWindowService(windowService) {
        this.windowService = windowService;
        this.anyPopupsOpen = false;
        this.windowRefs = [];
    }
    PopupWindowService.prototype.openPopupWindow = function (popupContent, titleTemplate, width, height, left, top, params) {
        var _this = this;
        if (width === void 0) { width = null; }
        if (height === void 0) { height = null; }
        if (left === void 0) { left = null; }
        if (top === void 0) { top = null; }
        if (params === void 0) { params = null; }
        var windowRef = this.windowService.open({
            title: 'Test',
            content: popupContent,
            draggable: false,
            resizable: false,
            titleBarContent: titleTemplate,
            width: width,
            height: height,
            left: left,
            top: top
        });
        if (params) {
            var instance_1 = windowRef.content.instance;
            Object.keys(params).forEach(function (p) { return instance_1[p] = params[p]; });
        }
        this.windowRefs.push(windowRef);
        this.anyPopupsOpen = true;
        windowRef.window.onDestroy(function () {
            if (_this.windowRefs.includes(windowRef)) {
                _this.windowRefs.splice(_this.windowRefs.findIndex(function (entry) { return entry === windowRef; }));
                _this.anyPopupsOpen = _this.windowRefs.length > 0;
            }
        });
        return windowRef.result;
    };
    PopupWindowService.prototype.closeAllPopups = function () {
        this.windowRefs.forEach(function (windowRef) { return windowRef.close(); });
        this.windowRefs = [];
        this.anyPopupsOpen = false;
    };
    PopupWindowService.prototype.closePopup = function (windowRef, arg) {
        windowRef.close(arg);
        this.windowRefs.splice(this.windowRefs.findIndex(function (entry) { return entry === windowRef; }));
        this.anyPopupsOpen = this.windowRefs.length > 0;
    };
    PopupWindowService.prototype.closeLatestPopup = function (arg) {
        if (this.windowRefs.length > 0) {
            this.windowRefs.pop().close(arg);
        }
        this.anyPopupsOpen = this.windowRefs.length > 0;
    };
    PopupWindowService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PopupWindowService_Factory() { return new PopupWindowService(i0.ɵɵinject(i1.WindowService)); }, token: PopupWindowService, providedIn: "root" });
    return PopupWindowService;
}());
export { PopupWindowService };
